(function() {
fd.navigation = {
    states: [],
    init: function() {
        if ("pushState" in history && "addEventListener" in window) {
            var handleClick = function(e, uri, title, callback) {
                e.preventDefault();

                fd.navigation.state.change(uri, title, callback);

                return false;
            };

            $(".sidebar a").click(function(e) {
                var el = $(this),
                    callback = function() {
                        $(".active").removeClass("active");

                        el.addClass("active");
                    };

                $(".active").removeClass("active");

                el.addClass("active");

                return handleClick(e, el.attr("href"), el.data("title"), callback);
            });

            window.addEventListener("popstate", fd.navigation.on.popstate, false);
        }
    },
    state: {
        add: function(url, title) {
            var state = {
                url: url,
                title: title,
                id: "body" + (fd.navigation.states.length + 1)
            };

            fd.navigation.states.push(state);

            return state;
        },
        change: function(url, title, callback) {
            var state;

            if (fd.navigation.states.length == 0) {
                // TODO: history.state === null
                state = fd.navigation.state.add(location.href, document.title);

                history.replaceState(state, "", location.href);

                $(".body:visible")
                    .attr("id", state.id)
                    .data("callback", callback);
            }

            $(".body:visible").hide();

            state = fd.navigation.state.add(url, title);

            history.pushState(state, title, url);

            var body = $(
                '<div class="' + $(".body:last").attr("class") + '" id="' + state.id + '">' +
                    '<i class="fa fa-refresh fa-spin fa-3x fa-fw"></i>' +
                    '<span class="sr-only">Loading...</span>' +
                '</div>'
            ).data("callback", callback);

            $(".body:last").after(body);

            $.get("/api/page" + url).success(function(data) {
                $("#" + state.id).children().remove();
                $("#" + state.id).html(data.html);

                document.title = state.title = data.title;

                history.replaceState(state, "", state.url);
            });

            document.title = "Loading";
        }
    },
    on: {
        popstate: function(e) {
            document.title = e.state.title;

            $(".body:visible").hide();
            var callback = $("#" + e.state.id).show().data("callback");

            callback();
        }
    }
}
})();